import React, { useState } from "react";
import styled from "styled-components";
import ExtensionInputGroup from "./ExtensionInputGroup";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import { toast } from "react-toastify";
import { useExtensionContext } from "../ExtensionContext";
import useInsertDealPayment from "app/popleads/hooks/useInsertDealPayment";
import { DEAL_WON } from "../utils/constants";

const StyledItemContainer = styled("div")`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    gap: 8px;
`;

const ExtensionAddPayment = ({ getDealPayments }) => {
    const { selectedDeal, setState } = useExtensionContext();
    const { loading, insertDealPayment } = useInsertDealPayment();
    const [paymentAmount, setPaymentAmount] = useState("");

    if (selectedDeal?.durum !== DEAL_WON || selectedDeal?.paidAmount === selectedDeal?.amount) {
        return null;
    }

    const handlePayment = async () => {
        if (!paymentAmount) {
            toast.warning("Please enter payment value");
            return;
        }
        if (paymentAmount <= 0) {
            toast.warning("Payment amount must be greater than 0");
            return;
        }

        try {
            await insertDealPayment(selectedDeal.id, paymentAmount);
            await getDealPayments();
            setPaymentAmount("");
            // Set dealPaymentAdded to true to trigger re-render in ExtensionDealExEdCampaigns
            setState((prevState) => ({
                ...prevState,
                dealPaymentAdded: true,
            }));
        } catch (error) {
            // Error is already handled in the hook
        }
    };

    return (
        <StyledItemContainer>
            <ExtensionInputGroup
                type="input"
                inpType="number"
                min={0}
                leftIcon="dollar-sign"
                onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e" || e.key === "+") {
                        e.preventDefault();
                    }
                }}
                onChange={(e) => {
                    setPaymentAmount(e.target ? e.target.value : e);
                }}
                minLength={1}
                placeholder="Add payment"
                value={paymentAmount}
                size="small"
            />
            <ButtonWithText
                variant="primary"
                buttonStyle="default"
                size="midSmall"
                onClick={handlePayment}
                disabled={loading}
            >
                {loading ? "Processing..." : "Pay"}
            </ButtonWithText>
        </StyledItemContainer>
    );
};

export default ExtensionAddPayment;
